(function () {
  "use strict";

  // Worker URL injected from Liquid (pp-ids, per environment).
  // Falls back to the known worker URL if not injected.
  const PROXY_BASE =
    (typeof window.UH_WORKER_URL !== "undefined" && window.UH_WORKER_URL)
      ? window.UH_WORKER_URL
      : "https://uh-returns-worker.ritu-4eb.workers.dev";
  window.UH_RETURNS_STATE = {
    order: null,
    returnableItems: [],
    selectedItems: [],
    itemReasons: {},
    currentItemIndex: 0,
    photos: {},      // variantId → Array of File objects
  };

  function $(id) {
    return document.getElementById(id);
  }

  function setPanel(id) {
    document.querySelectorAll(".uh-rp-panel").forEach(function (p) {
      p.classList.remove("active");
    });
    var panel = document.getElementById(id);
    if (panel) panel.classList.add("active");
    updateProgressBar(id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function updateProgressBar(panelId) {
    var pct = {
      "panel-1": 0,
      "panel-3": 33,
      "panel-4": 55,
      "panel-5a": 66,
      "panel-5b": 66,
      "panel-5c": 66,
      "panel-5d": 66,
      "panel-6": 88,
      "panel-7": 100,
    };
    var fill = $("uh-progress-fill");
    if (fill) fill.style.width = (pct[panelId] || 0) + "%";

    document.querySelectorAll("#uh-progress-steps span").forEach(function (span) {
      span.classList.toggle("active", span.dataset.panel === panelId);
    });
  }

  function clearFieldErrors() {
    document
      .querySelectorAll("#uh-returns-portal .uh-field-error")
      .forEach(function (el) {
        el.remove();
      });
  }

  function showFieldError(inputEl, message) {
    if (!inputEl) return;
    var existing = inputEl.parentElement.querySelector(".uh-field-error");
    if (existing) existing.remove();
    var err = document.createElement("div");
    err.className = "uh-field-error";
    err.setAttribute("role", "alert");
    err.textContent = message;
    inputEl.insertAdjacentElement("afterend", err);
  }

  function showLookupError(message) {
    var el = $("lookup-error");
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function hideLookupError() {
    var el = $("lookup-error");
    if (!el) return;
    el.textContent = "";
    el.hidden = true;
  }

  function runEligibilityChecks(order) {
    var state = window.UH_RETURNS_STATE;
    var reasonEl = $("eligibility-reason");

    // Check if order is unfulfilled
    if (order.is_unfulfilled) {
      if (reasonEl) {
        reasonEl.innerHTML =
          "This order has not been fulfilled yet and is not " +
          "eligible for a return. Please wait until your order " +
          "has been shipped and delivered before requesting a return. " +
          "If you have questions, please " +
          "<a href='https://uncleharrys.com/pages/contact' " +
          "style='color:#c62828;font-weight:600;" +
          "text-decoration:underline'>contact us</a>.";
      }
      setPanel("panel-2");
      return;
    }

    // Check if order already has an active return
    if (order.has_active_return) {
      if (reasonEl) {
        reasonEl.innerHTML = 
          "A return request is already in progress for this order. " +
          "If you need further assistance, please " +
          "<a href='https://uncleharrys.com/pages/contact' " +
          "style='color:#c62828;font-weight:600;" +
          "text-decoration:underline'>contact us</a>.";
      }
      setPanel("panel-2");
      return;
    }

    if (order.shipping_address?.country_code !== "US") {
      if (reasonEl) {
        reasonEl.textContent = "We do not accept international returns.";
      }
      setPanel("panel-2");
      return;
    }

    var days =
      (Date.now() - new Date(order.processed_at).getTime()) / 86400000;
    if (days > 60) {
      if (reasonEl) {
        reasonEl.textContent =
          "Your order is outside the 60-day return window.";
      }
      setPanel("panel-2");
      return;
    }

    var lineItems = order.line_items || [];
    var allDiscount = lineItems.every(function (i) {
      return (i.product_tags || []).includes("discount-shelf");
    });
    if (allDiscount) {
      if (reasonEl) {
        reasonEl.textContent =
          "Discount shelf items are final sale and cannot be returned.";
      }
      setPanel("panel-2");
      return;
    }

    // Detect whether this order included the protection product,
    // matched by variant ID (injected from Liquid via pp-ids,
    // so it is correct per environment). Falls back to false if
    // the ID wasn't injected.
    var PROTECTION_VARIANT_ID =
      (typeof window.UH_PROTECTION_VARIANT_ID !== "undefined")
        ? String(window.UH_PROTECTION_VARIANT_ID) : "";
    // All protection variants ever used — legacy orders carry
    // older IDs, so match against the full list.
    var PROTECTION_VARIANT_IDS =
      (typeof window.UH_PROTECTION_VARIANT_IDS !== "undefined" &&
       window.UH_PROTECTION_VARIANT_IDS)
        ? String(window.UH_PROTECTION_VARIANT_IDS).split(",").map(function (s) { return s.trim(); })
        : [PROTECTION_VARIANT_ID];
    function isProtectionVariant(id) {
      return PROTECTION_VARIANT_IDS.indexOf(String(id)) !== -1;
    }
    function isProtectionProduct(item) {
      var title = String(item.title || "").toLowerCase();
      return isProtectionVariant(item.variant_id) ||
        title.indexOf("free returns") !== -1 ||
        title.indexOf("package protection") !== -1;
    }
    state.hasProtection =
      lineItems.some(function (i) {
        return isProtectionProduct(i);
      });

    state.returnableItems = lineItems
      .filter(function (i) {
        // Hide the protection product from returnable items,
        // matched by variant ID (per-environment, injected).
        if (isProtectionProduct(i)) {
          return false;
        }
        return true;
      })
      .filter(function (i) {
        return parseFloat(i.price) > 0;
      })
      .map(function (i) {
        var combined = (
          (i.title || "") + " " + (i.variant_title || "")
        ).toLowerCase();
        var isNonRefundable =
          combined.includes("nonrefundable") ||
          combined.includes("non-refundable") ||
          combined.includes("non refundable") ||
          combined.includes("non-returnable") ||
          combined.includes("non returnable");
        var isDiscountShelf =
          (i.product_tags || []).includes("discount-shelf") ||
          combined.includes("discount");
        return Object.assign({}, i, {
          nonrefundable: isNonRefundable,
          discount_shelf: isDiscountShelf,
          not_returnable: isNonRefundable || isDiscountShelf,
        });
      });

    renderItems();
    setPanel("panel-3");
  }

  function formatPrice(price) {
    var n = parseFloat(price);
    if (isNaN(n)) return price;
    return "$" + n.toFixed(2);
  }

  function updateItemsContinueState() {
    var btn = $("btn-items-continue");
    var list = $("item-list");
    if (!btn || !list) return;
    var checked = list.querySelectorAll(
      'input[type="checkbox"]:checked'
    );
    btn.disabled = checked.length === 0;

    var state = window.UH_RETURNS_STATE;

    // Build selectedItems — one entry per checked unit
    // Each entry is a copy of the item with quantity: 1
    // and a unique key combining variant_id + unitIndex
    var seen = {};
    state.selectedItems = Array.from(checked).map(function (cb) {
      var item = state.returnableItems[
        Number(cb.dataset.itemIndex)
      ];
      var unitIndex = cb.dataset.unitIndex || '0';
      // Create a unique copy per unit so each can have
      // its own reason/photo in state.itemReasons
      var unitKey = item.variant_id + '_' + unitIndex;
      return Object.assign({}, item, {
        quantity: 1,
        unit_key: unitKey
      });
    });
  }

  function renderItems() {
    var state = window.UH_RETURNS_STATE;
    var list = $("item-list");
    if (!list) return;

    list.innerHTML = "";
    state.selectedItems = [];

    state.returnableItems.forEach(function (item, index) {
      console.log('Item image URL:', item.title, item.image);
      // Expand by quantity — show one row per unit
      var qty = parseInt(item.quantity) || 1;
      var returnedQty = parseInt(item.returned_quantity) || 0;
      for (var q = 0; q < qty; q++) {

        // Only the first `returnedQty` units of this line are already returned.
        var unitAlreadyReturned = q < returnedQty;

      var row = document.createElement("div");
      row.className = "uh-rp-item";

      var checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      // Use index_q as unique key per unit
      checkbox.dataset.itemIndex = String(index);
      checkbox.dataset.unitIndex = String(q);
      if (unitAlreadyReturned) {
        checkbox.disabled = true;
        checkbox.title = "Return already submitted for this unit";
      } else if (item.not_returnable) {
        checkbox.disabled = true;
        checkbox.title = item.discount_shelf
          ? "Discount / final-sale items cannot be returned"
          : "Non-refundable items cannot be returned";
      } else {
        checkbox.addEventListener("change", updateItemsContinueState);
      }

      var img = document.createElement("img");
      img.alt = item.title || "Product";
      img.width = 60;
      img.height = 60;
      img.style.cssText = "width:60px;height:60px;object-fit:cover;border-radius:4px;background:#f5f5f5";
      if (item.image) {
        img.src = item.image;
        img.onerror = function() {
          this.style.display = "none";
        };
      } else {
        img.style.display = "none";
      }

      var main = document.createElement("div");
      main.className = "uh-rp-item-main";
      var name = document.createElement("div");
      name.textContent = item.title || "";
      main.appendChild(name);

      if (item.variant_title) {
        var variant = document.createElement("div");
        variant.textContent = item.variant_title;
        main.appendChild(variant);
      }

      if (item.nonrefundable) {
        var badge = document.createElement("span");
        badge.className = "uh-badge-nr";
        badge.textContent = "Non-refundable";
        main.appendChild(badge);
      }

      if (item.discount_shelf) {
        var dbadge = document.createElement("span");
        dbadge.className = "uh-badge-nr";
        dbadge.textContent = "Final sale";
        main.appendChild(dbadge);
      }

      if (item.not_returnable && !unitAlreadyReturned) {
        row.style.opacity = "0.6";
        row.style.cursor = "not-allowed";
      }

      if (unitAlreadyReturned) {
        var returnedBadge = document.createElement("span");
        returnedBadge.className = "uh-badge-returned";
        returnedBadge.textContent = "Return already submitted";
        main.appendChild(returnedBadge);
        row.style.opacity = "0.6";
        row.style.cursor = "not-allowed";
      }

      var price = document.createElement("div");
      price.className = "uh-rp-item-price";
      price.textContent = formatPrice(item.price);

      row.appendChild(checkbox);
      row.appendChild(img);
      row.appendChild(main);
      row.appendChild(price);
      list.appendChild(row);

      } // end quantity loop
    });

    updateItemsContinueState();
  }

  async function handleLookup() {
    var emailInput = $("input-email");
    var orderInput = $("input-order");
    var btn = $("btn-lookup");

    clearFieldErrors();
    hideLookupError();

    var email = (emailInput?.value || "").trim();
    var orderNumber = (orderInput?.value || "").trim();
    var valid = true;

    if (!email) {
      showFieldError(emailInput, "Email address is required.");
      valid = false;
    }
    if (!orderNumber) {
      showFieldError(orderInput, "Order number is required.");
      valid = false;
    }
    if (!valid) return;

    var originalText = btn ? btn.textContent : "Find My Order";
    if (btn) {
      btn.textContent = "Searching...";
      btn.disabled = true;
    }

    try {
      var res = await fetch(PROXY_BASE + "/lookup-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email, orderNumber: orderNumber }),
      });

      if (res.status === 404) {
        showLookupError(
          "Order not found. Please check your email and order " +
          "number. If your order is older than 60 days, it is " +
          "outside our return window."
        );
        return;
      }

      if (!res.ok) {
        showLookupError("Connection error. Please try again.");
        return;
      }

      var data = await res.json();
      window.UH_RETURNS_STATE.order = data.order;
      window.UH_RETURNS_STATE.orderNumber = orderNumber;
      runEligibilityChecks(data.order);
    } catch (err) {
      showLookupError("Connection error. Please try again.");
    } finally {
      if (btn) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    }
  }

  function showNextItemReason() {
    var state = window.UH_RETURNS_STATE;
    if (state.currentItemIndex >= state.selectedItems.length) {
      renderReview();
      setPanel("panel-6");
      return;
    }
    var item = state.selectedItems[state.currentItemIndex];
    if (!item) return;

    // Use unit_key as the reason/photo storage key
    var itemKey = item.unit_key || item.variant_id;

    var nameEl = $("current-item-name");
    var progressEl = $("reason-item-progress");
    if (nameEl) nameEl.textContent = item.title +
      (item.variant_title ? " — " + item.variant_title : "");
    if (progressEl) progressEl.textContent =
      "Item " + (state.currentItemIndex + 1) +
      " of " + state.selectedItems.length;

    // Show item card at top of reason panel
    var itemCardEl = $("reason-item-card");
    if (!itemCardEl) {
      itemCardEl = document.createElement("div");
      itemCardEl.id = "reason-item-card";
      itemCardEl.style.cssText = 
        "display:flex;align-items:center;gap:16px;" +
        "background:#f0f7f0;border:1px solid #c8e6c9;" +
        "border-radius:10px;padding:14px 16px;" +
        "margin-bottom:20px;";
      var panel4 = $("panel-4");
      if (panel4) {
        panel4.insertBefore(itemCardEl, panel4.firstChild);
      }
    }

    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + 
        (item.title || "") + 
        '" style="width:56px;height:56px;object-fit:cover;' +
        'border-radius:6px;flex-shrink:0">'
      : '<div style="width:56px;height:56px;background:#ddd;' +
        'border-radius:6px;flex-shrink:0"></div>';

    itemCardEl.innerHTML = 
      imgHtml +
      '<div>' +
      '<div style="font-weight:600;color:#3d6b47;font-size:15px">' +
      (item.title || "") + '</div>' +
      (item.variant_title 
        ? '<div style="font-size:13px;color:#666;margin-top:2px">' + 
          item.variant_title + '</div>' 
        : '') +
      '<div style="font-size:13px;color:#888;margin-top:2px">$' +
      parseFloat(item.price || 0).toFixed(2) + '</div>' +
      '</div>';

    // Restore saved reason selection if going back
    var itemKey = item.unit_key || item.variant_id;
    var savedReason = state.itemReasons[itemKey];

    document.querySelectorAll(
      '#panel-4 input[name="return-reason"]'
    ).forEach(function (r) { r.checked = false; });

    if (savedReason && savedReason.reason) {
      var savedRadio = document.querySelector(
        '#panel-4 input[name="return-reason"]' +
        '[value="' + savedReason.reason + '"]'
      );
      if (savedRadio) savedRadio.checked = true;
    }

    var btnReasonContinue = $("btn-reason-continue");
    if (btnReasonContinue) {
      btnReasonContinue.disabled = 
        !(savedReason && savedReason.reason);
    }
    setPanel("panel-4");
  }

  function escapeHtml(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatReviewPrice(price) {
    var n = parseFloat(price);
    if (isNaN(n)) return escapeHtml(price || "");
    return "$" + n.toFixed(2);
  }

  function formatReviewSubreasons(subreason, subLabels) {
    if (!subreason) return "";
    return subreason.split(", ").map(function (s) {
      var label = subLabels[s] || s;
      return label.replace(/^Did not like /i, "");
    }).join(", ");
  }

  function getReviewCondition(r, reasonLabels) {
    if (r.reason === "damaged") return reasonLabels.damaged;
    if (r.reason === "wrong") return reasonLabels.wrong;
    if (r.reason === "disliked") {
      return r.returnType === "green_no_send_back"
        ? "No send-back required"
        : "Must send back";
    }
    if (r.reason === "other") return reasonLabels.other;
    return "";
  }

  function wireReviewPhotoLightbox(container) {
    var lightbox = $("uh-review-lightbox");
    var lightboxImg = $("uh-review-lightbox-img");
    var closeBtn = lightbox
      ? lightbox.querySelector(".uh-review-lightbox-close")
      : null;
    if (!container || !lightbox || !lightboxImg) return;

    function openLightbox(src, alt) {
      lightboxImg.src = src;
      lightboxImg.alt = alt || "Return photo";
      lightbox.hidden = false;
      document.body.style.overflow = "hidden";
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightboxImg.src = "";
      document.body.style.overflow = "";
    }

    container.querySelectorAll(".uh-review-photo-thumb-wrap").forEach(function (wrap) {
      var img = wrap.querySelector(".uh-review-photo-thumb");
      if (!img) return;
      wrap.addEventListener("click", function () {
        openLightbox(img.src, img.alt);
      });
    });

    container.querySelectorAll(".uh-review-photo-more").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var start = Number(btn.getAttribute("data-start")) || 0;
        var target = container.querySelector(
          '.uh-review-photo-thumb[data-photo-index="' + start + '"]'
        );
        if (target) openLightbox(target.src, target.alt);
      });
    });

    if (!lightbox.dataset.wired) {
      lightbox.dataset.wired = "true";
      if (closeBtn) {
        closeBtn.addEventListener("click", closeLightbox);
      }
      lightbox.addEventListener("click", function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !lightbox.hidden) closeLightbox();
      });
    }
  }

  function renderReview() {
    var state = window.UH_RETURNS_STATE;
    var summary = $("review-summary");
    if (!summary) return;

    var reasonLabels = {
      disliked: "Changed my mind",
      damaged: "Item is Damaged",
      wrong: "Received Wrong Item",
      other: "Other"
    };
    var subLabels = {
      taste: "Did not like taste",
      texture: "Did not like texture",
      smell: "Did not like smell",
      other: "Other"
    };

    var html = "";
    state.selectedItems.forEach(function (item) {
      var itemKey = item.unit_key || item.variant_id;
      var r = state.itemReasons[itemKey] || {};
      var itemPhotos = state.photos[itemKey] || [];
      var reasonText = reasonLabels[r.reason] || r.reason || "—";
      var subText = formatReviewSubreasons(r.subreason, subLabels);
      if (subText) reasonText += " — " + subText;
      var conditionText = getReviewCondition(r, reasonLabels);
      var qty = item.quantity || 1;

      html += '<article class="uh-review-card">';

      html += '<div class="uh-review-card-product">';
      html += '<div class="uh-review-card-image-wrap">';
      if (item.image) {
        html += '<img class="uh-review-card-image" src="' +
          escapeHtml(item.image) + '" alt="' +
          escapeHtml(item.title || "Product") + '">';
      } else {
        html += '<div class="uh-review-card-image-placeholder" aria-hidden="true"></div>';
      }
      html += '</div>';
      html += '<div class="uh-review-card-product-meta">';
      html += '<h3 class="uh-review-card-title">' +
        escapeHtml(item.title || "Product") + '</h3>';
      if (item.variant_title) {
        html += '<p class="uh-review-card-variant">' +
          escapeHtml(item.variant_title) + '</p>';
      }
      html += '<p class="uh-review-card-qty-price">Qty: ' + qty +
        ' &nbsp;|&nbsp; Price: ' + formatReviewPrice(item.price) + '</p>';
      html += '</div></div>';

      html += '<div class="uh-review-card-details">';
      html += '<div class="uh-review-kv">';
      html += '<span class="uh-review-kv-label">Reason</span>';
      html += '<span class="uh-review-kv-value">' + escapeHtml(reasonText) + '</span>';
      html += '</div>';
      if (r.detail) {
        html += '<div class="uh-review-kv">';
        html += '<span class="uh-review-kv-label">Details</span>';
        html += '<span class="uh-review-kv-value">' + escapeHtml(r.detail) + '</span>';
        html += '</div>';
      }
      if (r.lotNumber) {
        html += '<div class="uh-review-kv">';
        html += '<span class="uh-review-kv-label">Lot Code</span>';
        html += '<span class="uh-review-kv-value">' +
          escapeHtml(r.lotNumber) + '</span>';
        html += '</div>';
      }
      if (r.usedBefore) {
        html += '<div class="uh-review-kv">';
        html += '<span class="uh-review-kv-label">Used Before</span>';
        html += '<span class="uh-review-kv-value">' +
          (r.usedBefore === "yes" ? "Yes" : "No") + '</span>';
        html += '</div>';
      }
      if (conditionText) {
        html += '<div class="uh-review-kv">';
        html += '<span class="uh-review-kv-label">Condition</span>';
        html += '<span class="uh-review-kv-value">' +
          escapeHtml(conditionText) + '</span>';
        html += '</div>';
      }
      html += '</div>';

      html += '<div class="uh-review-card-photos">';
      if (itemPhotos.length > 0) {
        html += '<p class="uh-review-photos-label">📷 Photos Attached (' +
          itemPhotos.length + ')</p>';
        html += '<div class="uh-review-photos-row">';

        var validPhotos = itemPhotos.filter(function (f) {
          return f && f.type && f.type.indexOf("image/") === 0;
        });
        var maxVisible = 5;
        var showMore = validPhotos.length > maxVisible;
        var visibleCount = showMore ? maxVisible - 1 : validPhotos.length;
        var hiddenCount = validPhotos.length - visibleCount;

        validPhotos.forEach(function (photoFile, photoIndex) {
          if (photoIndex >= visibleCount) return;
          var thumbUrl = URL.createObjectURL(photoFile);
          html += '<button type="button" class="uh-review-photo-thumb-wrap">';
          html += '<img class="uh-review-photo-thumb" src="' + thumbUrl +
            '" alt="Return photo" data-photo-index="' + photoIndex + '">';
          html += '</button>';
        });

        if (showMore) {
          html += '<button type="button" class="uh-review-photo-more" data-start="' +
            visibleCount + '">+' + hiddenCount + ' More</button>';
          validPhotos.forEach(function (photoFile, photoIndex) {
            if (photoIndex < visibleCount) return;
            var hiddenUrl = URL.createObjectURL(photoFile);
            html += '<img class="uh-review-photo-thumb uh-review-photo-hidden" src="' +
              hiddenUrl + '" alt="Return photo" data-photo-index="' +
              photoIndex + '" hidden>';
          });
        }

        html += '</div>';
      }
      html += '</div>';

      html += '</article>';
    });

    // Return-shipping notice based on package protection
    var noticeEl = document.getElementById("uh-shipping-notice");
    if (noticeEl) {
      if (state.hasProtection) {
        noticeEl.className = "uh-ship-notice uh-ship-notice--ok";
        noticeEl.innerHTML =
          "<span class='uh-ship-notice-icon'>✓</span>" +
          "<span>Return shipping is covered by your package " +
          "protection \u2014 you won\u2019t be charged for " +
          "return shipping.</span>";
      } else {
        noticeEl.className = "uh-ship-notice uh-ship-notice--warn";
        noticeEl.innerHTML =
          "<span class='uh-ship-notice-icon'>\u24d8</span>" +
          "<span>Because package protection wasn\u2019t added to " +
          "this order, return shipping costs may be charged.</span>";
      }
    }

    summary.innerHTML = html;
    wireReviewPhotoLightbox(summary);
  }

  // Resolves a list of fileIds to CDN URLs in parallel.
  // Polls /check-photo for each until ready (max ~30s each).
  // Returns an array of URLs (skips any that fail/timeout).
  async function resolveAllPhotoUrls(fileIds) {
    if (!fileIds || fileIds.length === 0) return [];

    async function resolveOne(fileId) {
      var MAX = 15; // 15 × 2s = 30s
      for (var a = 0; a < MAX; a++) {
        try {
          var res = await fetch(PROXY_BASE + '/check-photo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ fileId: fileId })
          });
          var data = await res.json();
          if (data.ready && data.url) return data.url;
          if (data.failed) return null;
        } catch (e) { /* retry */ }
        await new Promise(function (r) { setTimeout(r, 2000); });
      }
      return null; // timed out
    }

    var results = await Promise.all(fileIds.map(resolveOne));
    return results.filter(function (u) { return !!u; });
  }

  // Renders thumbnails for the given input's selected files,
  // each with a × delete control. Deleting rebuilds the input's
  // FileList (via DataTransfer) and re-renders. Reads from the
  // input by id so delete can write back to the same input.
  function renderPhotoPreview(inputId, containerId) {
    var container = document.getElementById(containerId);
    var input = document.getElementById(inputId);
    if (!container || !input) return;
    container.innerHTML = "";
    var files = Array.from(input.files || []).slice(0, 5);
    files.forEach(function (file, index) {
      if (!file.type || file.type.indexOf("image/") !== 0) return;
      var url = URL.createObjectURL(file);

      var wrap = document.createElement("div");
      wrap.className = "uh-thumb-wrap";

      var img = document.createElement("img");
      img.src = url;
      img.className = "uh-thumb-img";
      img.alt = "Return photo";
      img.onload = function () { URL.revokeObjectURL(url); };

      var del = document.createElement("button");
      del.type = "button";
      del.className = "uh-thumb-del";
      del.setAttribute("aria-label", "Remove photo");
      del.textContent = "×";
      del.addEventListener("click", function () {
        var dt = new DataTransfer();
        Array.from(input.files || []).forEach(function (f, i) {
          if (i !== index) dt.items.add(f);
        });
        input.files = dt.files;
        renderPhotoPreview(inputId, containerId);
      });

      wrap.appendChild(img);
      wrap.appendChild(del);
      container.appendChild(wrap);
    });
  }

  // Restores previously-selected photos (from state.photos)
  // back into a file input via DataTransfer, then renders real
  // thumbnails. Makes thumbnails + delete work after navigation
  // and lets validation pass without forcing re-upload.
  function restorePhotosToInput(inputId, previewId, itemKey) {
    var input = document.getElementById(inputId);
    if (!input) return;
    var state = window.UH_RETURNS_STATE;
    var saved = (state.photos && state.photos[itemKey]) || [];
    if (saved.length > 0) {
      var dt = new DataTransfer();
      saved.forEach(function (f) { if (f) dt.items.add(f); });
      input.files = dt.files;
    } else {
      input.value = "";
    }
    renderPhotoPreview(inputId, previewId);
  }

  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // Resize + compress an image file client-side before upload.
  // Downscales to maxDim on the longest edge and re-encodes as
  // JPEG at the given quality. Falls back to the original file
  // if anything goes wrong (e.g. HEIC the browser can't decode).
  function compressImage(file, maxDim, quality) {
    maxDim = maxDim || 1600;
    quality = quality || 0.8;
    return new Promise(function (resolve) {
      // Only attempt for raster images the browser can decode
      if (!file.type || file.type.indexOf("image/") !== 0) {
        resolve(file);
        return;
      }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        try {
          var w = img.naturalWidth;
          var h = img.naturalHeight;
          if (!w || !h) { URL.revokeObjectURL(url); resolve(file); return; }

          var scale = Math.min(1, maxDim / Math.max(w, h));
          var targetW = Math.round(w * scale);
          var targetH = Math.round(h * scale);

          var canvas = document.createElement("canvas");
          canvas.width = targetW;
          canvas.height = targetH;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, targetW, targetH);
          URL.revokeObjectURL(url);

          canvas.toBlob(function (blob) {
            if (!blob) { resolve(file); return; }
            // If compression didn't help, keep the smaller one
            if (blob.size >= file.size) { resolve(file); return; }
            var newName = (file.name || "photo")
              .replace(/\.(heic|heif|png|webp)$/i, ".jpg");
            if (!/\.jpe?g$/i.test(newName)) newName += ".jpg";
            var out = new File([blob], newName, {
              type: "image/jpeg",
              lastModified: Date.now()
            });
            resolve(out);
          }, "image/jpeg", quality);
        } catch (e) {
          URL.revokeObjectURL(url);
          resolve(file);
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        resolve(file); // e.g. HEIC undecodable — upload original
      };
      img.src = url;
    });
  }

  function mapReason(reason) {
    var map = {
      disliked: "UNWANTED",
      damaged: "DEFECTIVE",
      wrong: "WRONG_ITEM",
      other: "OTHER"
    };
    return map[reason] || "OTHER";
  }

  async function handleSubmit() {
    var state = window.UH_RETURNS_STATE;
    var btn = $("btn-submit");
    var submitError = $("submit-error");
    var confirmCheckbox = $("confirm-checkbox");

    if (!confirmCheckbox?.checked) return;
    if (submitError) submitError.hidden = true;

    var originalText = btn ? btn.textContent : "Submit Return Request";
    if (btn) {
      btn.textContent = "Submitting... please wait";
      btn.disabled = true;
    }

    try {
      // ── Step 1: Upload all photos, collect fileIds per item ──────────────
      // state.photos[variantId] is now an ARRAY of files.
      // We upload each, collecting fileIds. After submit we poll all of them
      // and save the complete URL array in ONE call (avoids overwrite races).
      // Track fileIds per item (keyed by unit_key, same as state.photos)
      var allFileIds = [];
      state.itemFileIds = {};
      var photoEntries = Object.entries(state.photos);

      for (var i = 0; i < photoEntries.length; i++) {
        var photoKey = photoEntries[i][0];
        var files = photoEntries[i][1];
        if (!Array.isArray(files)) files = [files];
        state.itemFileIds[photoKey] = [];
        for (var f = 0; f < files.length; f++) {
          var file = files[f];
          try {
            // Shrink large phone photos before upload
            file = await compressImage(file, 1280, 0.7);
            var base64 = await fileToBase64(file);
            // Order number for filename, e.g. "#1066" -> "1066"
            var orderNumForFile = String(
              (state.order && state.order.name) ||
              state.orderNumber || ""
            ).replace(/^#/, "").replace(/[^A-Za-z0-9]/g, "");
            var uploadRes = await fetch(PROXY_BASE + "/upload-photo", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                base64Image: base64,
                mimeType: file.type,
                filename: "return-" +
                  (orderNumForFile ? orderNumForFile + "-" : "") +
                  Date.now() + "-" + f + "-" + file.name
              })
            });
            if (uploadRes.ok) {
              var uploadData = await uploadRes.json();
              if (uploadData.fileId) {
                allFileIds.push(uploadData.fileId);
                state.itemFileIds[photoKey].push(uploadData.fileId);
              }
            }
          } catch (uploadErr) {
            // Non-fatal — skip this photo
          }
        }
      }

      // ── Step 2: Build lineItems for /submit-return ───────────────────────
      var lineItems = state.selectedItems.map(function (item) {
        var itemKey = item.unit_key || item.variant_id;
        var r = state.itemReasons[itemKey] || {};
        return {
          line_item_id: item.id,
          quantity: 1,
          reason: mapReason(r.reason),
          customer_note: r.detail || ""
        };
      });

      // ── Step 3: Build noteObj (kept for audit trail in submit payload) ───
      var noteObj = {
        portal_submission: true,
        submitted_at: new Date().toISOString(),
        items: state.selectedItems.map(function (item) {
          var itemKey = item.unit_key || item.variant_id;
          return Object.assign(
            {
              line_item_id: item.id,
              variant_id: item.variant_id,
              variant_title: item.variant_title || '',
              unit_key: itemKey,
              title: item.title,
              price: item.price,
              quantity: 1,
              // fileIds so the worker can resolve photo URLs
              // server-side and email photo links
              photo_file_ids: (state.itemFileIds &&
                state.itemFileIds[itemKey]) || []
            },
            state.itemReasons[itemKey] || {}
          );
        })
      };

      // ── Step 4: Submit return to Shopify via worker ──────────────────────
      var submitRes = await fetch(PROXY_BASE + "/submit-return", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          orderId: state.order.id,
          lineItems: lineItems,
          noteObj: noteObj
        })
      });

      var submitData = await submitRes.json();

      if (!submitRes.ok || !submitData.success) {
        var errorDetail = "";
        if (submitData.details) {
          if (Array.isArray(submitData.details)) {
            errorDetail = submitData.details
              .map(function (e) {
                return e.message || e.field || JSON.stringify(e);
              })
              .join(", ");
          } else {
            errorDetail = JSON.stringify(submitData.details);
          }
        }
        var fullError = (submitData.message || submitData.error ||
          "Submission failed") +
          (errorDetail ? ": " + errorDetail : "");
        throw new Error(fullError);
      }

      var returnId = submitData.returnId;

      // ── Step 5: Build per-item array, resolve photos, save in ONE call ────
      var reasonLabelMap = {
        disliked: "Changed my mind",
        damaged:  "Damaged or Defective",
        wrong:    "Wrong Item Received",
        other:    "Other"
      };
      var subLabelMap = {
        taste: "Did not like taste",
        texture: "Did not like texture",
        smell: "Did not like smell",
        other: "Other"
      };

      var itemsArray = [];
      for (var si = 0; si < state.selectedItems.length; si++) {
        var it  = state.selectedItems[si];
        var key = it.unit_key || it.variant_id;
        var r   = state.itemReasons[key] || {};

        var thisItemUrls = [];
        if (state.itemFileIds && state.itemFileIds[key]) {
          thisItemUrls = await resolveAllPhotoUrls(state.itemFileIds[key]);
        }

        itemsArray.push({
          title:       it.title || "",
          variant:     it.variant_title || "",
          price:       it.price || "",
          unit_key:    it.unit_key || "",
          variant_id:  it.variant_id || "",
          line_item_id: it.id || "",
          reason:      reasonLabelMap[r.reason] || r.reason || "",
          sub_reason:  r.subreason
                         ? r.subreason.split(", ").map(function (s) {
                             return subLabelMap[s] || s; }).join(", ")
                         : "",
          lot_number:  r.lotNumber || "",
          used_before: r.usedBefore === "yes" ? "Yes"
                         : r.usedBefore === "no" ? "No" : "",
          detail:      r.detail || "",
          return_type: r.returnType === "green_no_send_back"
                         ? "No send-back" : "Send back",
          photo_urls:  thisItemUrls
        });
      }

      var first = itemsArray[0] || {};
      var allPhotoUrls = itemsArray.reduce(function (acc, x) {
        return acc.concat(x.photo_urls || []);
      }, []);

      try {
        var metaPayload = {
          orderId:         state.order.id,
          returnId:        returnId,
          reason:          first.reason      || "",
          return_type:     first.return_type || "",
          sub_reason:      first.sub_reason   || "",
          lot_number:      first.lot_number   || "",
          used_before:     first.used_before  || "",
          customer_detail: first.detail       || "",
          photo_urls:      allPhotoUrls,
          items:           itemsArray
        };

        await fetch(PROXY_BASE + "/save-return-meta", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(metaPayload)
        });
      } catch (metaErr) {
        // Non-fatal — return already created in Shopify
      }

      // ── Step 6: Show success screen ──────────────────────────────────────
      // Customer is done. Do not wait for photo URL before showing this.
      var orderId = state.order ? state.order.id : "";
      sessionStorage.setItem(
        "uh_return_submitted_order",
        String(orderId) + "_success_" + Date.now()
      );

      var refEl = $("confirmation-ref");
      if (refEl) {
        refEl.textContent = returnId ? "#" + returnId : "Submitted";
      }
      var msgEl = $("confirmation-message");
      if (msgEl) {
        msgEl.textContent =
          "Thank you. Your return request has been received. " +
          "Our team will review it and contact you at " +
          state.order.email +
          " within 2-3 business days.";
      }
      setPanel("panel-7");

    } catch (err) {
      sessionStorage.removeItem("uh_return_submitted_order");
      if (submitError) {
        var errorMsg = err.message || "Submission failed. Please try again.";

        if (errorMsg.includes("already exists") ||
            errorMsg.includes("already_returned") ||
            errorMsg.includes("already in progress")) {
          submitError.innerHTML =
            "<strong>Return already in progress</strong><br>" +
            "A return request already exists for one or more " +
            "of the selected items. If you need further assistance, " +
            "please <a href='https://uncleharrys.com/pages/contact'>" +
            "contact us</a>.";

        } else if (errorMsg.includes("Return creation failed")) {
          submitError.innerHTML =
            "<strong>Unable to process return</strong><br>" +
            errorMsg.replace("Return creation failed: ", "") +
            "<br>Please " +
            "<a href='https://uncleharrys.com/pages/contact'>" +
            "contact us</a> for assistance.";

        } else if (errorMsg.includes("invalid quantity") ||
                   errorMsg.includes("invalid_quantity")) {
          submitError.innerHTML =
            "<strong>Return already in progress</strong><br>" +
            "One or more of the selected items may already have " +
            "a return request in progress. Please " +
            "<a href='https://uncleharrys.com/pages/contact'>" +
            "contact us</a> for assistance.";

        } else if (errorMsg.includes("not fulfilled") ||
                   errorMsg.includes("not eligible") ||
                   errorMsg.includes("not_eligible")) {
          submitError.innerHTML =
            "<strong>Return not available</strong><br>" +
            "This order is not currently eligible for a return. " +
            "Please " +
            "<a href='https://uncleharrys.com/pages/contact'>" +
            "contact us</a> for assistance.";

        } else if (errorMsg.includes("No matching fulfillment")) {
          submitError.innerHTML =
            "<strong>Return not available</strong><br>" +
            "This order has not been fulfilled yet and cannot " +
            "be returned at this time. Please " +
            "<a href='https://uncleharrys.com/pages/contact'>" +
            "contact us</a> for assistance.";

        } else {
          submitError.innerHTML =
            "<strong>Something went wrong</strong><br>" +
            "We could not process your return request. Please " +
            "<a href='https://uncleharrys.com/pages/contact'>" +
            "contact us</a> and we will help you.";
        }
        submitError.hidden = false;
      }
      if (btn) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var btnLookup = $("btn-lookup");
    if (btnLookup) {
      btnLookup.addEventListener("click", handleLookup);
    }
    updateProgressBar("panel-1");

    var btnItemsContinue = $("btn-items-continue");
    if (btnItemsContinue) {
      btnItemsContinue.addEventListener("click", function () {
        var state = window.UH_RETURNS_STATE;
        if (state.selectedItems.length === 0) return;

        // Preserve reason/photo data for items that are still
        // selected. Only prune data for items that were
        // deselected on the Items panel. This keeps filled
        // information when navigating back and forward.
        var selectedKeys = {};
        state.selectedItems.forEach(function (item) {
          var key = item.unit_key || item.variant_id;
          selectedKeys[key] = true;
        });
        Object.keys(state.itemReasons).forEach(function (key) {
          if (!selectedKeys[key]) delete state.itemReasons[key];
        });
        Object.keys(state.photos).forEach(function (key) {
          if (!selectedKeys[key]) delete state.photos[key];
        });

        state.currentItemIndex = 0;
        showNextItemReason();
      });
    }

    document.querySelectorAll(
      '#panel-4 input[name="return-reason"]'
    ).forEach(function (radio) {
      radio.addEventListener("change", function () {
        var btn = $("btn-reason-continue");
        if (btn) btn.disabled = false;
      });
    });

    var btnReasonContinue = $("btn-reason-continue");
    if (btnReasonContinue) {
      btnReasonContinue.addEventListener("click", function () {
        var state = window.UH_RETURNS_STATE;
        var selected = document.querySelector(
          '#panel-4 input[name="return-reason"]:checked'
        );
        if (!selected) return;
        var item = state.selectedItems[state.currentItemIndex];
        var itemKey = item.unit_key || item.variant_id;

        // Keep all saved data when the reason is UNCHANGED.
        // Only start fresh when a DIFFERENT reason is chosen.
        var prevData = state.itemReasons[itemKey] || {};
        if (prevData.reason && prevData.reason === selected.value) {
          state.itemReasons[itemKey] = prevData;
        } else {
          state.itemReasons[itemKey] = { reason: selected.value };
        }

        var currentItem = 
          state.selectedItems[state.currentItemIndex];
        var currentKey = 
          currentItem.unit_key || currentItem.variant_id;
        var currentSaved = state.itemReasons[currentKey] || {};

        if (selected.value === "disliked") {
          // Restore subreason checkboxes if saved
          document.querySelectorAll(
            '#panel-5a input[name="dislike-subreason"]'
          ).forEach(function (r) { r.checked = false; });
          if (currentSaved.subreason) {
            var savedSubs = currentSaved.subreason.split(", ");
            document.querySelectorAll(
              '#panel-5a input[name="dislike-subreason"]'
            ).forEach(function(cb) {
              if (savedSubs.indexOf(cb.value) !== -1) {
                cb.checked = true;
              }
            });
          }
          var btn5a = $("btn-5a-continue");
          if (btn5a) {
            btn5a.disabled = !document.querySelector(
              '#panel-5a input[name="dislike-subreason"]:checked'
            );
          }
          setPanel("panel-5a");

        } else if (selected.value === "damaged") {
          var h = $("damaged-heading");
          if (h) h.textContent = "Item is Damaged";
          // Restore detail text if saved
          var dd5c = $("damaged-detail");
          if (dd5c) dd5c.value = currentSaved.detail || "";
          restorePhotosToInput(
            "photo-upload", "photo-preview", currentKey
          );
          setPanel("panel-5c");

        } else if (selected.value === "wrong") {
          var h2 = $("damaged-heading");
          if (h2) h2.textContent = "Received Wrong Item";
          // Restore detail text if saved
          var dd5cw = $("damaged-detail");
          if (dd5cw) dd5cw.value = currentSaved.detail || "";
          restorePhotosToInput(
            "photo-upload", "photo-preview", currentKey
          );
          setPanel("panel-5c");

        } else if (selected.value === "other") {
          // Restore other detail if saved
          var od = $("other-detail");
          if (od) od.value = currentSaved.detail || "";
          setPanel("panel-5d");
        }
      });
    }

    document.querySelectorAll(
      '#panel-5a input[name="dislike-subreason"]'
    ).forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        var anyChecked = document.querySelectorAll(
          '#panel-5a input[name="dislike-subreason"]:checked'
        ).length > 0;
        var btn = $("btn-5a-continue");
        if (btn) btn.disabled = !anyChecked;
      });
    });

    var btn5aContinue = $("btn-5a-continue");
    if (btn5aContinue) {
      btn5aContinue.addEventListener("click", function () {
        var state = window.UH_RETURNS_STATE;

        // Get all checked subreasons (multi-select)
        var checked = document.querySelectorAll(
          '#panel-5a input[name="dislike-subreason"]:checked'
        );
        if (checked.length === 0) return;

        var item = state.selectedItems[state.currentItemIndex];
        var itemKey = item.unit_key || item.variant_id;
        var subLabels = {
          taste: "Did not like taste",
          texture: "Did not like texture",
          smell: "Did not like smell",
          other: "Other"
        };
        var selectedValues = Array.from(checked)
          .map(function(cb) { return cb.value; });
        var selectedLabels = selectedValues
          .map(function(v) { return subLabels[v] || v; })
          .join(", ");

        state.itemReasons[itemKey].subreason = 
          selectedValues.join(", ");

        var labelEl = $("dislike-subreason-label");
        if (labelEl) labelEl.textContent = selectedLabels;

        // Restore panel-5b saved values if going back
        var item5a = state.selectedItems[state.currentItemIndex];
        var key5a = item5a.unit_key || item5a.variant_id;
        var saved5b = state.itemReasons[key5a] || {};

        var dd = $("dislike-detail");
        if (dd) dd.value = saved5b.detail || "";

        var ln = $("lot-number");
        if (ln) ln.value = saved5b.lotNumber || "";

        // Restore used-before radio
        document.querySelectorAll(
          '#panel-5b input[name="used-before"]'
        ).forEach(function(r) { r.checked = false; });
        if (saved5b.usedBefore) {
          var savedUsed = document.querySelector(
            '#panel-5b input[name="used-before"]' +
            '[value="' + saved5b.usedBefore + '"]'
          );
          if (savedUsed) savedUsed.checked = true;
        }

        // Restore previously uploaded photos as real thumbnails
        restorePhotosToInput(
          "dislike-photo", "dislike-photo-preview", key5a
        );

        setPanel("panel-5b");
      });
    }

    // Clear lot number error when user types
    var lotNumberInput = $("lot-number");
    if (lotNumberInput) {
      lotNumberInput.addEventListener("input", function () {
        var existing = lotNumberInput.parentElement
          .querySelector(".uh-field-error");
        if (existing) existing.remove();
      });
    }

    // Clear used-before error when user selects
    document.querySelectorAll(
      '#panel-5b input[name="used-before"]'
    ).forEach(function(radio) {
      radio.addEventListener("change", function() {
        var group = $("used-before-group");
        if (group) {
          var existing = group.parentElement
            .querySelector(".uh-field-error");
          if (existing) existing.remove();
        }
      });
    });

    var dislikeDetail = $("dislike-detail");
    if (dislikeDetail) {
      dislikeDetail.addEventListener("input", function () {
        var counter = dislikeDetail.parentElement
          .querySelector(".char-count");
        if (counter) counter.textContent =
          dislikeDetail.value.length + " / 500 characters";
      });
    }

    var btn5bContinue = $("btn-5b-continue");
    if (btn5bContinue) {
      btn5bContinue.addEventListener("click", function () {
        var state = window.UH_RETURNS_STATE;
        var item = state.selectedItems[state.currentItemIndex];
        var itemKey = item.unit_key || item.variant_id;
        var detail = ($("dislike-detail")?.value || "").trim();
        var lotNumber = ($("lot-number")?.value || "").trim();
        var usedBefore = document.querySelector(
          '#panel-5b input[name="used-before"]:checked'
        );

        var valid = true;
        if (!detail) {
          showFieldError($("dislike-detail"),
            "Please describe your experience.");
          valid = false;
        }
        if (!lotNumber) {
          showFieldError($("lot-number"),
            "Please enter the lot code.");
          valid = false;
        }
        if (!usedBefore) {
          showFieldError($("used-before-group"),
            "Please select an option.");
          valid = false;
        }
        if (!valid) return;

        // Photos are mandatory for disliked product (1-5 photos)
        var dislikePhotoError = $("dislike-photo-error");
        var dislikeFiles = Array.from($("dislike-photo")?.files || []);

        // Fall back to previously uploaded photos if the file
        // input is empty (browser clears it on navigation) but
        // photos already exist in state from an earlier pass.
        var existingDislikePhotos = state.photos[itemKey] || [];
        if (dislikeFiles.length === 0 &&
            existingDislikePhotos.length > 0) {
          dislikeFiles = existingDislikePhotos;
        }

        if (dislikeFiles.length === 0) {
          if (dislikePhotoError) {
            dislikePhotoError.textContent = "Please upload at least one photo.";
            dislikePhotoError.hidden = false;
            dislikePhotoError.className = "uh-field-error";
          }
          valid = false;
        } else if (dislikeFiles.length > 5) {
          if (dislikePhotoError) {
            dislikePhotoError.textContent = "Maximum 5 photos allowed.";
            dislikePhotoError.hidden = false;
            dislikePhotoError.className = "uh-field-error";
          }
          valid = false;
        } else {
          var photoValid = true;
          for (var pf = 0; pf < dislikeFiles.length; pf++) {
            if (!dislikeFiles[pf].type.startsWith("image/")) {
              dislikePhotoError.textContent = "All files must be images.";
              dislikePhotoError.hidden = false;
              dislikePhotoError.className = "uh-field-error";
              photoValid = false; break;
            }
            if (dislikeFiles[pf].size > 25 * 1024 * 1024) {
              dislikePhotoError.textContent = "Each photo must be under 25MB.";
              dislikePhotoError.hidden = false;
              dislikePhotoError.className = "uh-field-error";
              photoValid = false; break;
            }
          }
          if (photoValid) {
            if (dislikePhotoError) {
              dislikePhotoError.hidden = true;
              dislikePhotoError.textContent = "";
            }
            state.photos[itemKey] = dislikeFiles;
          } else {
            valid = false;
          }
        }

        if (!valid) return;

        var price = parseFloat(item.price);
        var returnType = price < 11.00
          ? "green_no_send_back"
          : "must_send_back";

        state.itemReasons[itemKey] = Object.assign(
          state.itemReasons[itemKey] || {},
          {
            detail: detail,
            lotNumber: lotNumber,
            usedBefore: usedBefore.value,
            returnType: returnType
          }
        );

        state.currentItemIndex++;
        showNextItemReason();
      });
    }

    var damagedDetail = $("damaged-detail");
    if (damagedDetail) {
      damagedDetail.addEventListener("input", function () {
        var counter = damagedDetail.parentElement
          .querySelector(".char-count");
        if (counter) counter.textContent =
          damagedDetail.value.length + " / 500 characters";
      });
    }

    // Clear dislike photo error when user selects file
    var dislikePhotoMulti = $("dislike-photo");
    if (dislikePhotoMulti) {
      dislikePhotoMulti.addEventListener("change", function () {
        var err = $("dislike-photo-error");
        if (err) {
          err.hidden = true;
          err.textContent = "";
        }
        renderPhotoPreview("dislike-photo", "dislike-photo-preview");
      });
    }

    var photoUploadMulti = $("photo-upload");
    if (photoUploadMulti) {
      photoUploadMulti.addEventListener("change", function () {
        var photoError = $("photo-error");
        var files = Array.from(photoUploadMulti.files);
        if (!files.length) return;

        // Validate max 5 photos
        if (files.length > 5) {
          if (photoError) {
            photoError.textContent = 
              "Maximum 5 photos allowed.";
            photoError.hidden = false;
          }
          photoUploadMulti.value = "";
          return;
        }

        // Validate each file
        var invalid = false;
        for (var i = 0; i < files.length; i++) {
          if (!files[i].type.startsWith("image/")) {
            if (photoError) {
              photoError.textContent = 
                "Please upload image files only.";
              photoError.hidden = false;
            }
            photoUploadMulti.value = "";
            invalid = true;
            break;
          }
          if (files[i].size > 25 * 1024 * 1024) {
            if (photoError) {
              photoError.textContent = 
                files[i].name + " is too large. Max 25MB each.";
              photoError.hidden = false;
            }
            photoUploadMulti.value = "";
            invalid = true;
            break;
          }
        }
        if (invalid) return;

        if (photoError) photoError.hidden = true;
        renderPhotoPreview("photo-upload", "photo-preview");
      });
    }

    // ── Camera capture wiring ─────────────────────────────
    // The "Take Photo" button opens a camera-only input.
    // Each captured photo is MERGED into the main multi-select
    // input's FileList (not replaced), then the preview/thumbs
    // re-render. Total capped at 5.
    function wireCameraButton(btnId, cameraInputId,
                              mainInputId, previewId) {
      var btn = document.getElementById(btnId);
      var camInput = document.getElementById(cameraInputId);
      var mainInput = document.getElementById(mainInputId);
      if (!btn || !camInput || !mainInput) return;

      btn.addEventListener("click", function () {
        camInput.click();
      });

      camInput.addEventListener("change", async function () {
        var captured = Array.from(camInput.files || []);
        if (!captured.length) return;

        // Compress each captured photo IMMEDIATELY so the large
        // raw camera file (often 8-15MB) is never held in memory.
        // This lowers the memory pressure that can cause Android
        // to reload the tab after the camera app closes.
        var compressed = [];
        for (var c = 0; c < captured.length; c++) {
          try {
            compressed.push(
              await compressImage(captured[c], 1280, 0.7)
            );
          } catch (e) {
            compressed.push(captured[c]);
          }
        }

        var dt = new DataTransfer();
        // Keep existing selected photos first
        Array.from(mainInput.files || []).forEach(function (f) {
          if (dt.items.length < 5) dt.items.add(f);
        });
        // Append the newly captured (now compressed) photo(s),
        // cap total at 5
        compressed.forEach(function (f) {
          if (dt.items.length < 5) dt.items.add(f);
        });

        mainInput.files = dt.files;
        // Reset capture input so the same shot can be retaken
        camInput.value = "";
        // Clear any photo error and re-render thumbnails
        var dErr = document.getElementById("dislike-photo-error");
        var pErr = document.getElementById("photo-error");
        if (mainInputId === "dislike-photo" && dErr) {
          dErr.hidden = true; dErr.textContent = "";
        }
        if (mainInputId === "photo-upload" && pErr) {
          pErr.hidden = true;
        }
        renderPhotoPreview(mainInputId, previewId);
      });
    }

    wireCameraButton(
      "dislike-photo-camera-btn",
      "dislike-photo-camera",
      "dislike-photo",
      "dislike-photo-preview"
    );
    wireCameraButton(
      "photo-upload-camera-btn",
      "photo-upload-camera",
      "photo-upload",
      "photo-preview"
    );

    // On Android, taking a photo in-browser can cause the tab
    // to reload on low-memory devices (losing the return in
    // progress). Steer Android users to the gallery-upload path
    // instead: hide the in-browser camera button and show a hint
    // telling them to use their camera app first, then upload.
    (function () {
      var ua = navigator.userAgent || "";
      var isAndroid = /Android/i.test(ua);
      if (!isAndroid) return;

      function steerToGallery(cameraBtnId, hintAfterId) {
        var camBtn = document.getElementById(cameraBtnId);
        if (camBtn) camBtn.style.display = "none";
        var anchor = document.getElementById(hintAfterId);
        if (anchor && !document.getElementById(cameraBtnId + "-hint")) {
          var hint = document.createElement("small");
          hint.id = cameraBtnId + "-hint";
          hint.className = "uh-android-photo-hint";
          hint.textContent =
            "On Android, please take your photo using your " +
            "camera app first, then tap \u201CChoose photos\u201D " +
            "above to upload it.";
          anchor.insertAdjacentElement("afterend", hint);
        }
      }

      steerToGallery("dislike-photo-camera-btn", "dislike-photo-camera-btn");
      steerToGallery("photo-upload-camera-btn", "photo-upload-camera-btn");
    })();

    var btn5cContinue = $("btn-5c-continue");
    if (btn5cContinue) {
      btn5cContinue.addEventListener("click", function () {
        var state = window.UH_RETURNS_STATE;
        var detail = ($("damaged-detail")?.value || "").trim();
        var photoError = $("photo-error");

        var valid = true;
        if (!detail) {
          showFieldError($("damaged-detail"),
            "Please describe the issue.");
          valid = false;
        }

        var damagedFiles = Array.from($("photo-upload")?.files || []);

        // Fall back to previously uploaded photos if the file
        // input is empty but photos already exist in state.
        var damagedItemKey = (function () {
          var it = state.selectedItems[state.currentItemIndex];
          return it ? (it.unit_key || it.variant_id) : null;
        })();
        var existingDamagedPhotos =
          (damagedItemKey && state.photos[damagedItemKey]) || [];
        if (damagedFiles.length === 0 &&
            existingDamagedPhotos.length > 0) {
          damagedFiles = existingDamagedPhotos;
        }

        if (damagedFiles.length === 0) {
          if (photoError) {
            photoError.textContent = "Please upload at least one photo.";
            photoError.hidden = false;
          }
          valid = false;
        } else if (damagedFiles.length > 5) {
          if (photoError) {
            photoError.textContent = "Maximum 5 photos allowed.";
            photoError.hidden = false;
          }
          valid = false;
        } else {
          for (var df = 0; df < damagedFiles.length; df++) {
            if (!damagedFiles[df].type.startsWith("image/")) {
              if (photoError) {
                photoError.textContent = "All files must be images.";
                photoError.hidden = false;
              }
              valid = false; break;
            }
            if (damagedFiles[df].size > 25 * 1024 * 1024) {
              if (photoError) {
                photoError.textContent = "Each photo must be under 25MB.";
                photoError.hidden = false;
              }
              valid = false; break;
            }
          }
        }

        if (!valid) return;

        var item = state.selectedItems[state.currentItemIndex];
        var itemKey = item.unit_key || item.variant_id;
        state.photos[itemKey] = damagedFiles;
        state.itemReasons[itemKey] = Object.assign(
          state.itemReasons[itemKey] || {},
          {
            detail: detail,
            returnType: "must_send_back"
          }
        );

        state.currentItemIndex++;
        showNextItemReason();
      });
    }

    var otherDetail = $("other-detail");
    if (otherDetail) {
      otherDetail.addEventListener("input", function () {
        var counter = otherDetail.parentElement
          .querySelector(".char-count");
        if (counter) counter.textContent =
          otherDetail.value.length + " / 500 characters";
      });
    }

    var btn5dContinue = $("btn-5d-continue");
    if (btn5dContinue) {
      btn5dContinue.addEventListener("click", function () {
        var state = window.UH_RETURNS_STATE;
        var detail = ($("other-detail")?.value || "").trim();

        if (detail.length < 20) {
          showFieldError($("other-detail"),
            "Please provide at least 20 characters.");
          return;
        }

        var item = state.selectedItems[state.currentItemIndex];
        var itemKey = item.unit_key || item.variant_id;
        state.itemReasons[itemKey] = Object.assign(
          state.itemReasons[itemKey] || {},
          {
            detail: detail,
            returnType: "must_send_back"
          }
        );

        state.currentItemIndex++;
        showNextItemReason();
      });
    }

    // Confirm checkbox enables submit button
    var confirmCheckbox = $("confirm-checkbox");
    var btnSubmit = $("btn-submit");
    if (confirmCheckbox && btnSubmit) {
      confirmCheckbox.addEventListener("change", function () {
        btnSubmit.disabled = !confirmCheckbox.checked;
      });
    }

    // Submit button
    if (btnSubmit) {
      btnSubmit.addEventListener("click", handleSubmit);
    }

    // ── Back button navigation ────────────────────────

    // panel-2 (rejection) → panel-1
    var btnBack2 = $("btn-back-2");
    if (btnBack2) {
      btnBack2.addEventListener("click", function () {
        setPanel("panel-1");
      });
    }

    // panel-3 (items) → panel-1
    var btnBack3 = $("btn-back-3");
    if (btnBack3) {
      btnBack3.addEventListener("click", function () {
        setPanel("panel-1");
      });
    }

    // panel-4 (reason) → panel-3
    var btnBack4 = $("btn-back-4");
    if (btnBack4) {
      btnBack4.addEventListener("click", function () {
        // If not first item, go back to previous item reason
        var state = window.UH_RETURNS_STATE;
        if (state.currentItemIndex > 0) {
          state.currentItemIndex--;
          showNextItemReason();
        } else {
          // First item — go back to item selection
          setPanel("panel-3");
        }
      });
    }

    // panel-5a (dislike subreason) → panel-4
    var btnBack5a = $("btn-back-5a");
    if (btnBack5a) {
      btnBack5a.addEventListener("click", function () {
        setPanel("panel-4");
      });
    }

    // panel-5b (dislike detail) → panel-5a
    var btnBack5b = $("btn-back-5b");
    if (btnBack5b) {
      btnBack5b.addEventListener("click", function () {
        setPanel("panel-5a");
      });
    }

    // panel-5c (damaged/wrong detail) → panel-4
    var btnBack5c = $("btn-back-5c");
    if (btnBack5c) {
      btnBack5c.addEventListener("click", function () {
        setPanel("panel-4");
      });
    }

    // panel-5d (other detail) → panel-4
    var btnBack5d = $("btn-back-5d");
    if (btnBack5d) {
      btnBack5d.addEventListener("click", function () {
        setPanel("panel-4");
      });
    }

    // panel-6 (review) → last item's sub-panel, restored
    // directly (no setTimeout). Sets currentItemIndex to the
    // last item and rebuilds the exact sub-panel for its saved
    // reason, restoring all fields and photos synchronously.
    var btnBack6 = $("btn-back-6");
    if (btnBack6) {
      btnBack6.addEventListener("click", function () {
        var state = window.UH_RETURNS_STATE;
        if (state.selectedItems.length === 0) {
          setPanel("panel-3");
          return;
        }

        state.currentItemIndex = state.selectedItems.length - 1;
        var lastItem =
          state.selectedItems[state.currentItemIndex];
        var lastKey = lastItem.unit_key || lastItem.variant_id;
        var saved = state.itemReasons[lastKey] || {};
        var lastReason = saved.reason;

        // Always set up panel-4 first (item card, reason radio).
        // showNextItemReason restores the reason selection.
        showNextItemReason();

        // If no reason saved yet, leave the user on panel-4.
        if (!lastReason) return;

        if (lastReason === 'disliked') {
          // Restore panel-5a subreason checkboxes
          document.querySelectorAll(
            '#panel-5a input[name="dislike-subreason"]'
          ).forEach(function (cb) { cb.checked = false; });
          if (saved.subreason) {
            var subs = saved.subreason.split(", ");
            document.querySelectorAll(
              '#panel-5a input[name="dislike-subreason"]'
            ).forEach(function (cb) {
              if (subs.indexOf(cb.value) !== -1) cb.checked = true;
            });
          }
          var labelEl = $("dislike-subreason-label");
          if (labelEl && saved.subreason) {
            var subLabels = {
              taste: "Did not like taste",
              texture: "Did not like texture",
              smell: "Did not like smell",
              other: "Other"
            };
            labelEl.textContent = saved.subreason
              .split(", ")
              .map(function (s) { return subLabels[s] || s; })
              .join(", ");
          }

          // Restore panel-5b fields
          var dd = $("dislike-detail");
          if (dd) dd.value = saved.detail || "";
          var ln = $("lot-number");
          if (ln) ln.value = saved.lotNumber || "";
          document.querySelectorAll(
            '#panel-5b input[name="used-before"]'
          ).forEach(function (rb) { rb.checked = false; });
          if (saved.usedBefore) {
            var ub = document.querySelector(
              '#panel-5b input[name="used-before"]' +
              '[value="' + saved.usedBefore + '"]'
            );
            if (ub) ub.checked = true;
          }
          restorePhotosToInput(
            "dislike-photo", "dislike-photo-preview", lastKey
          );
          setPanel("panel-5b");

        } else if (lastReason === 'damaged' ||
                   lastReason === 'wrong') {
          var dd2 = $("damaged-detail");
          if (dd2) dd2.value = saved.detail || "";
          var h = $("damaged-heading");
          if (h) h.textContent =
            lastReason === 'damaged'
              ? "Item is Damaged"
              : "Received Wrong Item";
          restorePhotosToInput(
            "photo-upload", "photo-preview", lastKey
          );
          setPanel("panel-5c");

        } else if (lastReason === 'other') {
          var od = $("other-detail");
          if (od) od.value = saved.detail || "";
          setPanel("panel-5d");
        }
      });
    }

    // Clear any stale submission state on fresh page load
    // sessionStorage only blocks resubmission within same session
    // after a confirmed successful submission
  });
})();
